// extracted by mini-css-extract-plugin
export default {"icon":"Spinner_icon__xmjvF","sm":"Spinner_sm__g1uIE","md":"Spinner_md__ck9CT","lg":"Spinner_lg__vCvm0","spinner":"Spinner_spinner__PA5Nv","spin":"Spinner_spin__xU3D9"};